import React, { useState, useEffect } from 'react';
import { Button, Card, Row, Col, Badge, Spin, Alert, message, Divider } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRef } from "react";
import { DownloadOutlined, SendOutlined } from '@ant-design/icons';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { FaUserMd } from "react-icons/fa";
import { IoMdArrowBack } from "react-icons/io";
import TransText from "../../translation/trans_tag";
import axiosInstance from '../../services/axiosConfig';

import logo_toscana from "../../icons/Regione.png";
import scritta_toscana from "../../icons/logo-regione-toscana.png";
import logo_estar from "../../icons/Estar.png";
import logo_fse from "../../icons/FSE-logo.png";
import Footer1 from "../../icons/Footer1.png";
import Footer2 from "../../icons/Footer2.png";
import Footer3 from "../../icons/Footer3.png";
import Footer4 from "../../icons/Footer4.png";
import { Pie, PieChart, ResponsiveContainer } from 'recharts';
import { Modal } from "react-bootstrap";
import Footer from "../../icons/Footer_alt.png";
import Header from "../../icons/image.png";
import Formas from "../../icons/formas.png"

const PatientReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const doctorData = location.state?.doctorData;
  const cardRef2 = useRef();
  const hiddenPdf1 = useRef();
  const hiddenPdf2 = useRef();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [patientSummary, setPatientSummary] = useState([]);
  const [reportData, setReportData] = useState(null);
  const [completationData, setCompletationData] = useState({
    startDate: '',
    endtDate: ''
  });
  const [modalVisible, setModalVisible] = useState(false);
  const [secondModalVisible, setSecondModalVisible] = useState(false);
  const [activeDocumentIndex, setActiveDocumentIndex] = useState(0);
  const [hoverDoc1, setHoverDoc1] = useState(false);
  const [hoverDoc2, setHoverDoc2] = useState(false);

  useEffect(() => {
    if (!doctorData) {
      console.error('No doctor data provided');
      setError('Dati del medico non disponibili');
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);
        const reportResponse = await axiosInstance.get(`/api/reports/discente/${doctorData.key}`);
        console.log('Report response:', reportResponse.data);
        if (reportResponse.data && reportResponse.data.report) {
          setReportData(reportResponse.data.report);
          if (reportResponse.data.report.infoSessione) {
            const sessionInfo = reportResponse.data.report.infoSessione;
            const startDate = new Date(sessionInfo.startDate);
            const endDate = new Date(sessionInfo.endDate);
            
            setCompletationData({
              startDate: `${startDate.getDate()}/${startDate.getMonth() + 1}/${startDate.getFullYear()} ${startDate.getHours()}:${startDate.getMinutes()}:${startDate.getSeconds()}`,
              endtDate: `${endDate.getDate()}/${endDate.getMonth() + 1}/${endDate.getFullYear()} ${endDate.getHours()}:${endDate.getMinutes()}:${endDate.getSeconds()}`
            });
          }
        }

        const statsResponse = await axiosInstance.get(`/api/reports/discente/${doctorData.key}/pss-stats`);
        if (statsResponse.data && statsResponse.data.stats) {
          setPatientSummary(statsResponse.data.stats);
        }
        
        setLoading(false);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Errore nel caricamento dei dati');
        setLoading(false);
      }
    };
    
    fetchData();
  }, [doctorData]);


  const showDocumentModal = (documentIndex) => {
    if (documentIndex === 0) {
      setModalVisible(true);
    } else {
      setSecondModalVisible(true);
    }
    setActiveDocumentIndex(documentIndex);
  };
   const handleDownloadPDF = async (documentIndex = 0) => {
    console.log(`Tentativo di generazione PDF per documento ${documentIndex}`);
    
    try {
      // Utilizziamo direttamente i riferimenti nascosti senza aprire i modali
      const element = documentIndex === 0 ? hiddenPdf1.current : hiddenPdf2.current;
      
      // Verifichiamo che l'elemento esista
      if (!element) {
        console.error(`Elemento nascosto non trovato per il documento ${documentIndex}`);
        alert(`Impossibile generare il PDF: elemento non trovato per il documento ${documentIndex === 0 ? 'report' : 'attestato'}`);
        return;
      }
      
      // Impostiamo le dimensioni A4 in pixel (595 x 842 a 72 DPI)
      const pdfWidth = 595;
      const pdfHeight = 842;
      
      // Crea una copia visibile ma temporanea dell'elemento per il rendering
      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'absolute';
      tempDiv.style.left = '0';
      tempDiv.style.top = '0';
      tempDiv.style.width = `${pdfWidth}px`;
      tempDiv.style.height = `${pdfHeight}px`;
      tempDiv.style.backgroundColor = '#ffffff';
      tempDiv.style.zIndex = '-9999'; // Nascondi visivamente ma mantieni nel flusso del documento
      
      // Clona l'elemento da rendere
      const clonedElement = element.cloneNode(true);
      clonedElement.style.width = `${pdfWidth}px`;
      clonedElement.style.height = `${pdfHeight}px`;
      clonedElement.style.margin = '0';
      clonedElement.style.padding = '0';
      clonedElement.style.boxShadow = 'none';
      
      // Assicuriamo che tutti i contenuti siano ben visibili
      const allElements = clonedElement.querySelectorAll('*');
      allElements.forEach(el => {
        if (el.style) {
          el.style.visibility = 'visible';
          el.style.opacity = '1';
        }
      });
      
      tempDiv.appendChild(clonedElement);
      document.body.appendChild(tempDiv);
      
      console.log("Elemento clonato aggiunto al DOM");
      
      // Assicura il caricamento corretto di tutte le immagini
      const images = Array.from(clonedElement.querySelectorAll('img'));
      for (const img of images) {
        if (!img.complete) {
          await new Promise(resolve => {
            img.onload = resolve;
            img.onerror = resolve;
            // Imposta nuovamente la src per forzare il caricamento
            const currentSrc = img.src;
            img.src = '';
            img.src = currentSrc;
          });
        }
        // Assicura che l'immagine sia visibile
        img.style.display = 'block';
        img.style.visibility = 'visible';
        img.style.opacity = '1';
        console.log(`Immagine caricata: ${img.src}`);
      }
      
      // Aspetta un attimo per assicurarsi che tutto il rendering sia completo
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Usiamo opzioni ottimizzate per html2canvas
      const canvas = await html2canvas(clonedElement, { 
        scale: 3,  // Aumentiamo leggermente la scala per maggiore nitidezza
        useCORS: true,
        logging: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        width: pdfWidth,
        height: pdfHeight,
        scrollX: 0,
        scrollY: 0,
        imageTimeout: 15000
      });
      
      // Creiamo un PDF A4 senza margini con un buon equilibrio tra qualità e dimensione
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',  // Usiamo punti per corrispondere ai pixel
        format: 'a4',
        compress: false,  // Riabilitiamo la compressione per ridurre la dimensione
        hotfixes: ["px_scaling"],
        putOnlyUsedFonts: true
      });


      // Utilizziamo l'intera pagina senza margini
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Genera il PDF con alta qualità e compressione ragionevole
      const imgData = canvas.toDataURL('image/png', 0.9); // PNG per testo nitido
      pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, pageHeight, undefined, 'FAST');
      
      // Nome del documento
      const docName = documentIndex === 0 ? 'Riepilogo' : 'Attestato';
      const fileName = `${docName}_FormazionePSS_${doctorData?.name}_${doctorData?.surname || 'discente'}.pdf`;
      
      // Generiamo un blob per il download diretto
      const pdfBlob = pdf.output('blob');
      
      // Crea un URL per il blob
      const blobUrl = URL.createObjectURL(pdfBlob);
      
      // Crea un elemento <a> per il download
      const downloadLink = document.createElement('a');
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;
      
      // Aggiungi l'elemento al DOM e simula il click
      document.body.appendChild(downloadLink);
      downloadLink.click();
      
      // Pulizia
      setTimeout(() => {
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(blobUrl);
      }, 100);
      
      // Pulizia: rimuovi l'elemento temporaneo
      document.body.removeChild(tempDiv);
      
      console.log(`PDF generato con successo per il documento ${documentIndex}`);
    } catch (error) {
      console.error("Errore durante la generazione del PDF:", error);
      alert("Si è verificato un errore durante la generazione del PDF. Controlla la console per i dettagli.");
    }
  };
  /**
   * Gestisce l'invio del PDF via email
   * @param {number} documentIndex - 0 per il report, 1 per l'attestato
   */
  const handleSendEmailPDF = async (documentIndex = 0) => {
    console.log(`Tentativo di invio email per documento ${documentIndex}`);
    
    try {
      // Prima generiamo il PDF
      // Utilizziamo direttamente i riferimenti nascosti senza aprire i modali
      const element = documentIndex === 0 ? hiddenPdf1.current : hiddenPdf2.current;
      
      // Verifichiamo che l'elemento esista
      if (!element) {
        console.error(`Elemento nascosto non trovato per il documento ${documentIndex}`);
        alert(`Impossibile generare il PDF: elemento non trovato per il documento ${documentIndex === 0 ? 'report' : 'attestato'}`);
        return;
      }
      
      // Impostiamo le dimensioni A4 in pixel (595 x 842 a 72 DPI)
      const pdfWidth = 595;
      const pdfHeight = 842;
      
      // Crea una copia visibile ma temporanea dell'elemento per il rendering
      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'absolute';
      tempDiv.style.left = '0';
      tempDiv.style.top = '0';
      tempDiv.style.width = `${pdfWidth}px`;
      tempDiv.style.height = `${pdfHeight}px`;
      tempDiv.style.backgroundColor = '#ffffff';
      tempDiv.style.zIndex = '-9999';
      
      // Clona l'elemento da rendere
      const clonedElement = element.cloneNode(true);
      clonedElement.style.width = `${pdfWidth}px`;
      clonedElement.style.height = `${pdfHeight}px`;
      clonedElement.style.margin = '0';
      clonedElement.style.padding = '0';
      clonedElement.style.boxShadow = 'none';
      
      
      // Assicuriamo che tutti i contenuti siano ben visibili
      const allElements = clonedElement.querySelectorAll('*');
      allElements.forEach(el => {
        if (el.style) {
          el.style.visibility = 'visible';
          el.style.opacity = '1';
        }
      });
      
      tempDiv.appendChild(clonedElement);
      document.body.appendChild(tempDiv);
      
      // Assicura il caricamento corretto di tutte le immagini
      const images = Array.from(clonedElement.querySelectorAll('img'));
      for (const img of images) {
        if (!img.complete) {
          await new Promise(resolve => {
            img.onload = resolve;
            img.onerror = resolve;
            const currentSrc = img.src;
            img.src = '';
            img.src = currentSrc;
          });
        }
        img.style.display = 'block';
        img.style.visibility = 'visible';
        img.style.opacity = '1';
      }
      
      await new Promise(resolve => setTimeout(resolve, 500));
      
      const canvas = await html2canvas(clonedElement, { 
        scale: 2,
        useCORS: true,
        logging: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        width: pdfWidth,
        height: pdfHeight,
        scrollX: 0,
        scrollY: 0,
        imageTimeout: 15000
      });
      
      // Creiamo un PDF A4 senza margini
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: 'a4',
        compress: true,
        hotfixes: ["px_scaling"]
      });
      pdf.setProperties({
        title: `Attestato formazione PSS - ${doctorData?.name} ${doctorData?.surname}`,
        // subject: `${docName} per ${patientData?.name || 'paziente'}`,
        // author: `${doctorData?.firstName || 'Dottore'} ${doctorData?.lastName || ''}`,
        // keywords: "report, attestato, paziente",
        // creator: "ITA-LSHS"
      });
      
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      
      const imgData = canvas.toDataURL('image/png', 1.0);
      pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, pageHeight, undefined, 'FAST');
      
      // Otteniamo il contenuto del PDF come stringa base64
      const pdfBase64 = pdf.output('datauristring').split(',')[1];
      
      // Pulizia dell'elemento temporaneo
      document.body.removeChild(tempDiv);
      
      // Otteniamo i dati del discente
      if (!reportData || !reportData.infoMedico) {
        throw new Error('Dati del medico non disponibili');
      }
      
      const { firstName, lastName, email } = reportData.infoMedico;
      const endDate = completationData.endtDate ? 
        completationData.endtDate.split(' ')[0] : 
        new Date().toISOString().split('T')[0];
      
      // Prepariamo i dati da inviare
      const emailData = {
        firstName,
        lastName,
        email,
        endDate,
        pdfBuffer: pdfBase64
      };
      
      // Inviamo i dati all'endpoint appropriato
      const endpoint = documentIndex === 0 ? 
        '/api/reports/send-email-riepilogo' : 
        '/api/reports/send-email-attestato';
      
      // Mostriamo un indicatore di caricamento
      // message.loading(`Invio dell'email in corso...`);
      
      // Inviamo la richiesta al backend
      const response = await axiosInstance.post(endpoint, emailData);
      
      if (response.data.success) {
        message.success(`${documentIndex === 0 ? 'Report' : 'Attestato'} inviato con successo all'indirizzo email del discente`);
      } else {
        throw new Error(response.data.message || 'Errore durante l\'invio dell\'email');
      }
    } catch (error) {
      console.error(`Errore durante l'invio dell'email:`, error);
      message.error(`Errore durante l'invio dell'email: riprova più tardi.`);
    }
  };

  const tutorName = reportData && reportData.infoTutor ? 
    `${reportData.infoTutor.firstName} ${reportData.infoTutor.lastName}` : 
    "";


  return (
    <>
    {/* Elementi nascosti per la generazione dei PDF */}
    <div style={{ position: 'absolute', left: '0', top: '-9999px', width: '595px', height: '842px', overflow: 'hidden', zIndex: -1000 }}>
      {/* Report nascosto */}
      <Card className='card-report' ref={hiddenPdf1} style={{ width: '595px', height: '842px', position: 'relative', margin: 0, boxShadow: 'none' }}>
        <div className="row header-row d-flex justify-content-between align-items-center">
          <img 
            src={Header} 
            alt="Header Logo"
            style={{ height: '50px', objectFit: 'contain' }}
          />
        </div>
        
        <div className='d-flex justify-content-center align-items-center flex-column' style={{ marginTop: '30px' }}>
          <h2 className='text-center fw-semibold' style={{ fontSize: '24px', marginBottom: '10px' }}><TransText i18nKey={'report.title'} /></h2>
          <h2 className='text-center' style={{ fontSize: '22px', marginBottom: '15px' }}><TransText i18nKey={'report.subtitle'} /></h2>
          <div style={{ fontSize: '18px', marginBottom: '30px' }}><em><TransText i18nKey={'report.tutor'} /> {tutorName}</em></div>
        </div>

          <div>
            <Row className='gap-3 mb-0'>
              <Col span={13}>
                <Badge.Ribbon 
                  text={<span  style = {{fontSize :"12px"}}>
                    <TransText i18nKey={'report.docData'} /></span>}
                  className="color-2"
                >
                  <Card className='mb-0'>
                    <div className='mt-2'>
                      <span className='fw-semibold' style = {{fontSize :"12px"}}><TransText i18nKey={'report.docName'} /> </span>
                      <span style = {{fontSize :"12px"}}>{`${reportData?.infoMedico?.firstName} ${reportData?.infoMedico?.lastName}`}</span>
                    </div>
                    <div>
                      <span className='fw-semibold' style = {{fontSize :"12px"}}>
                        <TransText i18nKey={'report.docSpecialization'} /> </span>
                      <span style = {{fontSize :"12px"}}>{reportData?.infoMedico?.typeMedico === 'MMG' 
                        ? 'Medico di Medicina Generale (MMG)'
                        : 'Pediatra di Libera Scelta (PLS)'
                      }</span>
                    </div> 
                    <div>
                      <span className='fw-semibold' style = {{fontSize :"12px"}}>
                        <TransText i18nKey={'report.areaVasta'} /> </span>
                      <span style = {{fontSize :"12px"}}>{reportData?.infoMedico?.areaVastaName}</span>
                    </div>
                  </Card>
                </Badge.Ribbon>
              </Col>
              
              <Col span={10}>
                <Badge.Ribbon 
                  text={<span style = {{fontSize :"12px"}}>
                    <TransText i18nKey={'report.sessionData'} /> </span>}
                  className="color-2"
                >
                  <Card>
                    <div className='mt-2'>
                      {
                        (() => {
                          const startDateParts = completationData.startDate.split(' ')[0];
                          const endDateParts = completationData.endtDate?.split(' ')[0];
                          
                          if (startDateParts === endDateParts) {
                            return <>
                              <div>
                                <span className='fw-semibold' style = {{fontSize :"12px"}}><TransText i18nKey={'report.sessionDate'} /></span> 
                                <span style = {{fontSize :"12px"}}>{startDateParts}</span>
                              </div>
                            </>
                          } else {
                            return ( <>
                              <div>
                                <span className='fw-semibold' style = {{fontSize :"12px"}}><TransText i18nKey={'report.startTime'} /></span> 
                                <span style = {{fontSize :"12px"}}>{startDateParts}</span>
                              </div>      
                              <div>
                                <span className='fw-semibold ' style = {{fontSize :"12px"}}><TransText i18nKey={'report.endTime'} /></span> 
                                <span style = {{fontSize :"12px"}}>{endDateParts}</span>
                              </div>
                            </>);
                          }
                        })()
                      } 
                      <span className='fw-semibold' style = {{fontSize :"12px"}}><TransText i18nKey={'report.totalTime'} /></span> 
                      {(() => {
                        if (completationData.startDate && completationData.endtDate) {
                          const startDatePart = completationData.startDate.split(' ')[0];
                          const endDatePart = completationData.endtDate.split(' ')[0];
                          
                          if (startDatePart === endDatePart) {
                            const startTime = completationData.startDate.split(' ')[1];
                            const endTime = completationData.endtDate.split(' ')[1];
                            
                            const [startHour, startMin, startSec] = startTime.split(':').map(Number);
                            const [endHour, endMin, endSec] = endTime.split(':').map(Number);
                            
                            const startMs = (startHour * 3600 + startMin * 60 + startSec) * 1000;
                            const endMs = (endHour * 3600 + endMin * 60 + endSec) * 1000;
                            
                            const diffMs = endMs - startMs;
                            const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
                            const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                            return <span  style = {{fontSize :"12px"}}>
                              {diffHrs === 0 
                                ? `${diffMins} ${diffMins === 1 ? 'minuto' : 'minuti'}`
                                : `${diffHrs} ${diffHrs === 1 ? 'ora' : 'ore'} e ${diffMins} ${diffMins === 1 ? 'minuto' : 'minuti'}`
                              }
                            </span>;
                          } else {
                            const [startDay, startMonth, startYear] = startDatePart.split('/').map(Number);
                            const [endDay, endMonth, endYear] = endDatePart.split('/').map(Number);
                            const startDate = new Date(startYear, startMonth - 1, startDay);
                            const endDate = new Date(endYear, endMonth - 1, endDay);
                            const diffTime = Math.abs(endDate - startDate);
                            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                            return <span style = {{fontSize :"12px"}}>{`${diffDays} ${diffDays === 1 ? 'giorno' : 'giorni'}`}</span>;
                          }
                        }
                        return '';
                      })()
                      }
                    </div> 
                  </Card>
                </Badge.Ribbon>
              </Col>
            </Row>
            
            <div className='mt-0'>
              <div className='fw-semibold text-center mb-2' style = {{fontSize :"18px"}}>
                <TransText i18nKey={'report.completedProfiles'} />
              </div>

                <Card>
                  <div className="row">
                    <div className="d-flex justify-content-around mb-0">
                      {patientSummary.slice(0, 3).map((category, index) => {
                        const chartData = [
                          { name: "Completati", value: category.completati, fill: "var(--second-color)" },
                          { name: "Non completati", value: category.nonCompletati, fill: "#E0E0E0" }
                        ];
                        
                        return (
                          <div key={index} className="text-center" style={{ width: "30%" }}>
                            <div className="fw-semibold mb-0" style = {{fontSize :"14px"}}>Paziente {category.cluster}</div>
                            <div className="mt-0"  style = {{fontSize :"12px"}}>
                              {category.completati}/{category.totali} completati
                            </div>
                            <ResponsiveContainer width="100%" height={100}>
                              <PieChart>
                                <Pie
                                  data={chartData}
                                  dataKey="value"
                                  cx="50%"
                                  cy="50%"
                                  outerRadius={30}
                                  labelLine={false}
                                  label={({ value }) => `${value}`}
                                  isAnimationActive={false}
                                />
                              </PieChart>
                            </ResponsiveContainer>
                          </div>
                        );
                      })}
                    </div>

                    {patientSummary.length > 3 && (
                      <div className="d-flex justify-content-center">
                        {patientSummary.slice(3, 5).map((category, index) => {
                          const chartData = [
                            { name: "Completati", value: category.completati, fill: "var(--second-color)" },
                            { name: "Non completati", value: category.nonCompletati, fill: "#E0E0E0" }
                          ];
                          
                          return (
                            <div key={index + 3} className="text-center mx-4" style={{ width: "30%" }}>
                              <div className="fw-semibold mb-0"  style = {{fontSize :"14px"}}>Paziente {category.cluster}</div>
                              <div className="mt-0"  style = {{fontSize :"12px"}}>
                                {category.completati}/{category.totali} completati
                              </div>
                              <ResponsiveContainer width="100%" height={100}>
                                <PieChart>
                                  <Pie
                                    data={chartData}
                                    dataKey="value"
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={30}
                                    labelLine={false}
                                    label={({ value }) => `${value}`}
                                    isAnimationActive={false}
                                  />
                                </PieChart>
                              </ResponsiveContainer>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </Card>
                          </div> 
                        </div>
        
        {/* Footer con loghi per il report */}
          <div className='position-absolute bottom-0 p-4 start-0 end-0 w-100'>
            <div style={{ padding: 0, width: '100%', backgroundColor: '#fff' }}>
              <div className="d-flex justify-content-center align-items-center h-100">
                <div className="d-flex justify-content-between align-items-center">
                  <img 
                    src={Footer} 
                    alt="Footer Logo"
                    style={{ height: '35px', objectFit: 'contain' }}
                  />
                  {/* <img 
                    src={Footer1} 
                    alt="Footer Logo 1"
                    style={{ height: '30px', width: '120px', objectFit: 'contain' }}
                  />
                  <img 
                    src={Footer2} 
                    alt="Footer Logo 2"
                    style={{ height: '30px', maxWidth: '80px', objectFit: 'contain' }}
                  />
                  <img 
                    src={Footer3} 
                    alt="Footer Logo 3"
                    style={{ height: '30px', maxWidth: '100px', objectFit: 'contain' }}
                  />
                  <img 
                    src={Footer4} 
                    alt="Footer Logo 4"
                    style={{ height: '25px', maxWidth: '150px', objectFit: 'contain' }}
                  /> */}
                </div>
              </div>
            </div>
          </div>
      </Card>

      {/* Attestato nascosto */}
      <Card className='card-report' ref={hiddenPdf2} style={{ width: '595px', height: '842px', position: 'relative', margin: 0, boxShadow: 'none' }}>
        <div className="w-100">
          <div className="row header-row d-flex justify-content-between align-items-center">
          {/* <img src={logo_toscana} alt="Logo Toscana" style={{ height: '35px', width: 'auto' }} className="p-0 ms-2"/> */}
          {/* <img src={scritta_toscana} alt="Scritta Toscana" style={{ height: '50px', width: 'auto' }} />
          <img src={logo_estar} alt="Logo Estar" style={{ height: '35px', width: 'auto' }} className="p-0"/>
          <img src={logo_fse} alt="Logo FSE" style={{ height: '35px', width: 'auto' }} className="p-0 me-3 ms-auto"/> */}
          <img 
            src={Header} 
            alt="Header Logo"
            style={{ height: '45px', objectFit: 'contain' }}
          />
          </div>
                  <Divider className ="my-3"/>

          
          <div className='pt-4 d-flex justify-content-center align-items-center flex-column'>
            <h3 className='text-center mt-3 mb-2' style={{color:"#364C8C"}}>ATTESTATO<br/> DI PARTECIPAZIONE</h3>
            
            {/* Certificate content */}
            <div className="text-center py-4">
              <h3 className="mb-2">
                {`${reportData?.infoMedico?.firstName || ''} ${reportData?.infoMedico?.lastName || ''}`}
              </h3>
              <div className="d-flex justify-content-center">
                <p className ="fw-semibold my-2" style ={{fontSize: "18px"}} >
                    ha partecipato al
                </p>
              </div>
                <p className="mx-5 border-bottom border-top pt-4 pb-4" style ={{fontSize: "20px"}}>
                  <span className="fw-semibold" style={{color:"#364C8C"}}>
                    CORSO DI FORMAZIONE IN AFFIANCAMENTO <br />
                    sul Fascicolo Sanitario Elettronico 2.0<br /> 
                    dedicato ai Medici di Medicina Generale e Pediatri di Libera Scelta
                  </span>
                  <br />
                </p>                   
                <div className="text-center mb-2" >
                    <p style ={{fontSize: "16px"}}>della durata di 4 ore</p>
                </div>
              </div>
              </div>
              <div className="d-flex justify-content-end me-4 mt-3">
                {/* <p style ={{fontSize: "16px"}}>Data di formazione: <br /> */}
                <p>{completationData.endtDate?.split(' ')[0]}</p>
              </div>
          
          {/* Footer con loghi */}
          <div className='position-absolute bottom-0 p-4 start-0 end-0 w-100'>
            <div style={{ padding: 0, width: '100%', backgroundColor: '#fff' }}>
              <div className="d-flex justify-content-center align-items-center h-100">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                  <img 
                    src={Footer} 
                    alt="Footer Logo"
                    style={{ height: '35px', objectFit: 'contain' }}
                  />
                  <span
                    style={{
                      fontSize: "7px",
                      lineHeight: "1",
                      letterSpacing: "-0.3px",
                      marginTop: "4px",
                      textAlign: "center",
                      width: "100%"
                    }}
                  >
                    <strong>Il piano di formazione sul FSE 2.0</strong> di Regione Toscana, finanziato dal PNRR (M6C2 1.3.1 b Adozione e utilizzo FSE da parte delle Regioni -  Risorse per competenze digitali)
                  </span>
                </div>              
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
    
    <div className ="container-xxl">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <Button
          type="link"
          className="button-responsive fs-6 ms-1"
          onClick={() => navigate('/elenco-discenti')}
        >
          <IoMdArrowBack />
          <TransText i18nKey={'patientList.back'} />
        </Button>
      </div>
      
      {doctorData && (
        <div>
          {/* Documents Section */}
          <div className="ms-5 me-5 mb-5 mt-2">
            {/* <div className="d-flex mb-4">
              <h3>Report Sessione formativa</h3>
            </div> */}
            
            <div className="d-flex justify-content-center gap-5 mx-5">
              {/* Document 1 Card */}
              <div className="card shadow col-6" style={{ 
                transition: 'all 0.3s ease',
                borderRadius: '8px',
                overflow: 'hidden',
                transform: hoverDoc1 ? 'translateY(-5px)' : 'none',
                boxShadow: hoverDoc1 ? '0 10px 20px rgba(0,0,0,0.15)' : '0 4px 8px rgba(0,0,0,0.1)'
              }}>
                <div className="card-body">
                  <h4 className="card-title mb-3">Riepilogo Sessione formativa</h4>
                  <div 
                    className="document-preview mb-3 border d-flex flex-column align-items-center justify-content-center overflow-hidden"
                    style={{ cursor: 'pointer', height: '300px', position: 'relative', boxShadow: 'inset 0 0 10px rgba(0,0,0,0.05)' }} 
                    onClick={() => showDocumentModal(0)}
                    onMouseEnter={() => setHoverDoc1(true)}
                    onMouseLeave={() => setHoverDoc1(false)}
                  >
                    {/* A4 paper-like preview with the original content */}
                    <div className="bg-light w-100 h-100 position-relative" style={{ padding: '0', overflow: 'hidden' }}>
                      <div style={{ 
                        width: '100%',
                        height: '100%', 
                        overflow: 'hidden',
                        position: 'relative'
                      }}>
                        {/* We create a paper effect with proper padding and sizing */}
                        <div style={{ 
                          width: '100%',
                          paddingTop: '20px',
                          position: 'relative',
                          transformOrigin: 'top center',
                          transform: 'scale(0.6)'
                        }}>
                          {/* <div className="card-report bg-white shadow-sm p-4" style={{ margin: '0 auto', maxWidth: '800px' }}>
                            {/* Report header */}
                            {/* <div className='d-flex justify-content-center align-items-center flex-column'>
                              <h2 className='mb-2'><TransText i18nKey={'report.title'} /></h2>
                              <h2><TransText i18nKey={'report.subtitle'} /></h2>
                              <div className='fs-5'><em><TransText i18nKey={'report.tutor'} /> {tutorName}</em></div>
                            </div> */}
                          <div className="card-report bg-white shadow-sm p-4 " style={{ margin: '0 auto', maxWidth: '1000px' }}>
                            {/* Document header */}
                            <div className="d-flex justify-content-between align-items-center opacity-50" style={{ height: '50px' }}>
                              <div className="d-flex gap-2">
                                <img src={logo_toscana} alt="Logo Toscana" height="40px" />
                                <img src={scritta_toscana} alt="Scritta Toscana" height="40px" />
                                <img src={logo_estar} alt="Logo Estar" height="40px"/>
                                <img src={Formas} alt="Formas Logo" height="40px" />
                              </div>
                              <img src={logo_fse} alt="FSE Logo" height="40px" />
                            </div>
                            
                            {/* Title */}
                            <div className="text-center my-4">
                              <h2 className="mt-5 mb-2"><TransText i18nKey={'report.title'} /></h2>
                              <h3><TransText i18nKey={'report.subtitle'} /></h3>
                              <div className='fs-5 mt-3'><em><TransText i18nKey={'report.tutor'} /> {tutorName}</em></div>
                            </div>

                            {/* Main content */}
                            <div className='mt-5'>
                              <Row className='mt-4 mb-4 gap-3'>
                                <Col span={11}>
                                  <Badge.Ribbon text={<span className="small"><TransText i18nKey={'report.docData'} /></span>} className="color-2">
                                    <Card className='mb-3'>
                                      <div>
                                        <span className='fw-bold me-1'><TransText i18nKey={'report.docName'} /></span>
                                        <span>{`${reportData?.infoMedico?.firstName || ''} ${reportData?.infoMedico?.lastName || ''}`}</span>
                                      </div>
                                      <div>
                                        <span className='fw-bold me-1'><TransText i18nKey={'report.docSpecialization'} /></span>
                                        <span>{reportData?.infoMedico?.typeMedico === 'MMG' ? 'Medico di Medicina Generale' : 'Pediatra di Libera Scelta'}</span>
                                      </div>
                                    </Card>
                                  </Badge.Ribbon>
                                </Col>
                                
                                <Col span={11}>
                                  <Badge.Ribbon text={<span className="small"><TransText i18nKey={'report.sessionData'} /></span>} className="color-2">
                                                  <Card>
                    <div className='mt-2'>
                      {
                        (() => {
                          const startDateParts = completationData.startDate.split(' ')[0];
                          const endDateParts = completationData.endtDate?.split(' ')[0];
                          
                          if (startDateParts === endDateParts) {
                            return <>
                              <div>
                                <span className='fw-semibold'><TransText i18nKey={'report.sessionDate'} /></span> 
                                <span >{startDateParts}</span>
                              </div>
                            </>
                          } else {
                            return ( <>
                              <div>
                                <span className='fw-semibold' ><TransText i18nKey={'report.startTime'} /></span> 
                                <span>{startDateParts}</span>
                              </div>      
                              <div>
                                <span className='fw-semibold'><TransText i18nKey={'report.endTime'} /></span> 
                                <span>{endDateParts}</span>
                              </div>
                            </>);
                          }
                        })()
                      } 
                      <span className='fw-semibold'><TransText i18nKey={'report.totalTime'} /></span> 
                      {(() => {
                        if (completationData.startDate && completationData.endtDate) {
                          const startDatePart = completationData.startDate.split(' ')[0];
                          const endDatePart = completationData.endtDate.split(' ')[0];
                          
                          if (startDatePart === endDatePart) {
                            const startTime = completationData.startDate.split(' ')[1];
                            const endTime = completationData.endtDate.split(' ')[1];
                            
                            const [startHour, startMin, startSec] = startTime.split(':').map(Number);
                            const [endHour, endMin, endSec] = endTime.split(':').map(Number);
                            
                            const startMs = (startHour * 3600 + startMin * 60 + startSec) * 1000;
                            const endMs = (endHour * 3600 + endMin * 60 + endSec) * 1000;
                            
                            const diffMs = endMs - startMs;
                            const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
                            const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                            return <span  >
                              {diffHrs === 0 
                                ? `${diffMins} ${diffMins === 1 ? 'minuto' : 'minuti'}`
                                : `${diffHrs} ${diffHrs === 1 ? 'ora' : 'ore'} e ${diffMins} ${diffMins === 1 ? 'minuto' : 'minuti'}`
                              }
                            </span>;
                          } else {
                            const [startDay, startMonth, startYear] = startDatePart.split('/').map(Number);
                            const [endDay, endMonth, endYear] = endDatePart.split('/').map(Number);
                            const startDate = new Date(startYear, startMonth - 1, startDay);
                            const endDate = new Date(endYear, endMonth - 1, endDay);
                            const diffTime = Math.abs(endDate - startDate);
                            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                            return <span>{`${diffDays} ${diffDays === 1 ? 'giorno' : 'giorni'}`}</span>;
                          }
                        }
                        return '';
                      })()
                      }
                    </div> 
                  </Card>
                                                    </Badge.Ribbon>
                                </Col>

                              </Row>
                              
                              {/* Charts section */}
                              <div className='text-center mb-2'>
                                <div className='fw-bold fs-4 mb-3'><TransText i18nKey={'report.completedProfiles'} /></div>
                                <div className="d-flex justify-content-center">
                                  {patientSummary.slice(0, 3).map((category, index) => {
                                    const chartData = [
                                      { name: "Completati", value: category.completati, fill: "var(--second-color)" },
                                      { name: "Non completati", value: category.nonCompletati, fill: "#E0E0E0" }
                                    ];
                                    
                                    return (
                                      <div key={index} className="text-center mx-2" style={{ width: "25%" }}>
                                        <div className="fw-semibold">Paziente {category.cluster}</div>
                                        <div>{category.completati}/{category.totali}</div>
                                        <ResponsiveContainer width="100%" height={120}>
                                          <PieChart>
                                            <Pie
                                              data={chartData}
                                              dataKey="value"
                                              cx="50%"
                                              cy="50%"
                                              outerRadius={40}
                                              labelLine={false}
                                              label={({ value }) => `${value}`}
                                              isAnimationActive={false}
                                            />
                                          </PieChart>
                                        </ResponsiveContainer>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="position-absolute w-100 h-100 top-0 start-0 d-flex flex-column justify-content-center align-items-center" 
                        style={{ 
                            background: 'rgba(255,255,255,0.85)', 
                            transition: 'all 0.2s ease',
                            opacity: hoverDoc1 ? 1 : 0
                        }}
                    >
                      <div className="text-center p-3">
                        <div className="text-muted fs-6">Clicca per visualizzare l'anteprima</div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <Button 
                      icon={<DownloadOutlined />}
                      className="button-responsive fs-6"
                      onClick={() => handleDownloadPDF(0)}
                    >
                      Scarica PDF
                    </Button>
                    {/* <Button 
                      type="primary" 
                      icon={<SendOutlined />}
                      className="button-color button-responsive fs-6"
                      onClick={() => handleSendEmailPDF(0)}
                    >
                      Invia al discente
                    </Button> */}
                  </div>
                </div>
              </div>
              
              {/* Document 2 Card */}
              <div className="card shadow col-6" style={{ 
                transition: 'all 0.3s ease',
                borderRadius: '8px',
                overflow: 'hidden',
                transform: hoverDoc2 ? 'translateY(-5px)' : 'none',
                boxShadow: hoverDoc2 ? '0 10px 20px rgba(0,0,0,0.15)' : '0 4px 8px rgba(0,0,0,0.1)'
              }}>
                <div className="card-body">
                  <h4 className="card-title mb-3">Attestato Sessione formativa</h4>
                  <div 
                    className="document-preview mb-3 border d-flex flex-column align-items-center justify-content-center overflow-hidden"
                    style={{ cursor: 'pointer', height: '300px', position: 'relative', boxShadow: 'inset 0 0 10px rgba(0,0,0,0.05)' }} 
                    onClick={() => showDocumentModal(1)}
                    onMouseEnter={() => setHoverDoc2(true)}
                    onMouseLeave={() => setHoverDoc2(false)}
                  >
                    {/* A4 paper-like preview with the original content */}
                    <div className="bg-light w-100 h-100 position-relative" style={{ padding: '0', overflow: 'hidden' }}>
                      <div style={{ 
                        width: '100%',
                        height: '100%', 
                        overflow: 'hidden',
                        position: 'relative'
                      }}>
                        {/* We create a paper effect with proper padding and sizing */}
                        <div style={{ 
                          width: '100%',
                          paddingTop: '20px',
                          position: 'relative',
                          transformOrigin: 'top center',
                          transform: 'scale(0.6)'
                        }}>
                          <div className="card-report bg-white shadow-sm p-4" style={{ margin: '0 auto', maxWidth: '800px' }}>
                            {/* Document header */}
                            <div className="d-flex justify-content-between align-items-center opacity-50" style={{ height: '60px' }}>
                              <div className="d-flex gap-2">
                                <img src={logo_toscana} alt="Logo Toscana" height="40px" />
                                <img src={scritta_toscana} alt="Scritta Toscana" height="40px" />
                                <img src={logo_estar} alt="Logo Estar" height="40px"/>
                                <img src={Formas} alt="Formas Logo" height="40px" />
                              </div>
                              <img src={logo_fse} alt="FSE Logo" height="40px" />
                            </div>
                            
                            <div className='mt-4 pt-2 d-flex justify-content-center align-items-center flex-column'>
                              <h2 className='text-center mt-3 mb-2' style={{color:"#364C8C"}}>ATTESTATO<br/> DI PARTECIPAZIONE</h2>
                              
                              <div className="text-center py-2">
                                <h3 className="mb-2">
                                  {`${reportData?.infoMedico?.firstName || ''} ${reportData?.infoMedico?.lastName || ''}`}
                                </h3>
                                <div className="d-flex justify-content-center">
                                  <p className="fs-6 fw-semibold my-1">
                                    ha partecipato al
                                  </p>
                                </div>
                                
                                <p className="fs-6 mx-3 my-2 border-bottom border-top pt-2 pb-2">
                                  <span className="fw-semibold" style={{color:"#364C8C"}}>
                                    CORSO DI FORMAZIONE IN AFFIANCAMENTO<br/>
                                    sul Fascicolo Sanitario Elettronico 2.0<br/> 
                                    dedicato ai Medici di Medicina Generale e Pediatri di Libera Scelta
                                  </span>
                                </p>                   
                                <div className="text-center">
                                  <p className="fs-6">della durata di 4 ore</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="position-absolute w-100 h-100 top-0 start-0 d-flex flex-column justify-content-center align-items-center" 
                         style={{ 
                           background: 'rgba(255,255,255,0.85)', 
                           transition: 'all 0.2s ease',
                           opacity: hoverDoc2 ? 1 : 0
                         }}
                    >
                      <div className="text-center p-3">
                        <div className="text-muted fs-6">Clicca per visualizzare l'anteprima</div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <Button 
                      icon={<DownloadOutlined />}
                      className=" button-responsive me-2 fs-6"
                      onClick={() => handleDownloadPDF(1)}
                    >
                      Scarica PDF 
                    </Button>
                    <Button 
                    type="primary" 
                      icon={<SendOutlined />}
                      className="button-color button-responsive fs-6 "
                      onClick={() => handleSendEmailPDF(1)}
                    >
                      Invia al discente
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Document Preview Modals */}
          <Modal 
            show={modalVisible} 
            onHide={() => setModalVisible(false)}
            size="lg"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Anteprima: Riepilogo Sessione formativa</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }} className ="bg-light">
              <div className="document-preview" style={{ transform: 'scale(0.7)', transformOrigin: 'top center' }}>
                <Card className='card-report'>
                <div className="w-100">
                {/* Document header with logos */}
                <div className="row header-row d-flex justify-content-between align-items-center">
                    <img src={logo_toscana} alt="Logo Toscana" style={{ height: '4vh', width: 'auto' }} className="p-0 ms-2"/>
                    <img src={scritta_toscana} alt="Scritta Toscana" style={{ height: '8vh', width: 'auto' }}/>
                    <img src={logo_estar} alt="Logo Estar" style={{ height: '4vh', width: 'auto' }} className="p-0"/>
                    <img src={Formas} alt="Logo Formas" style={{ height: '4vh', width: 'auto' }} className="p-0"/>
                    <img src={logo_fse} alt="Logo FSE" style={{ height: '5vh', width: 'auto' }} className="p-0 me-3 ms-auto"/>
                </div>
                
                <div className='d-flex justify-content-center align-items-center flex-column'>
                  <h2 className='mt-2 mb-2'><TransText i18nKey={'report.title'} /></h2>
                  <h2><TransText i18nKey={'report.subtitle'} /></h2>
                  <div className='fs-5'><em><TransText i18nKey={'report.tutor'} /> {tutorName}</em></div>
                </div>

                <div >
                  <Row className='mt-3 gap-3 mb-0'>
                    <Col span={13}>
                      <Badge.Ribbon 
                        text={<span className="fs-6 fw-semibold">
                          <TransText i18nKey={'report.docData'} /></span>}
                        className={`color-2  ${window.innerWidth >= 1400 ? 'p-1' : ''}`}
                      >
                        <Card className='mb-3'>
                          <div className='mt-3'>
                            <span className='fs-6 fw-bold'><TransText i18nKey={'report.docName'} /> </span>
                            <span className='fs-6'>{`${reportData?.infoMedico?.firstName} ${reportData?.infoMedico?.lastName}`}</span>
                          </div>
                          <div >
                            <span className='fs-6 fw-bold'>
                              <TransText i18nKey={'report.docSpecialization'} /> </span>
                            <span className='fs-6'>{reportData?.infoMedico?.typeMedico === 'MMG' 
                              ? 'Medico di Medicina Generale (MMG)'
                              : 'Pediatra di Libera Scelta (PLS)'
                            }</span>
                          </div> 
                          <div >
                            <span className='fs-6 fw-bold'>
                              <TransText i18nKey={'report.areaVasta'} /> </span>
                              <span className='fs-6'>{reportData?.infoMedico?.areaVastaName}</span>
                          </div>
                        </Card>
                      </Badge.Ribbon>
                    </Col>
                    
                    <Col span={10} >
                      <Badge.Ribbon 
                        text={<span className="fs-6 fw-semibold">
                          <TransText i18nKey={'report.sessionData'} /> </span>}
                        className={`color-2  ${window.innerWidth >= 1400 ? 'p-1' : ''}`}
                      >
                        <Card>
                          <div className='mt-3'>
                            {
                              (() => {
                                const startDateParts = completationData.startDate.split(' ')[0];
                                const endDateParts = completationData.endtDate?.split(' ')[0];
                                
                                if (startDateParts === endDateParts) {
                                  return <>
                                    <div>
                                      <span className='fw-bold fs-6 me-1'><TransText i18nKey={'report.sessionDate'} /></span> 
                                      <span className='fs-6'>{startDateParts}</span>
                                    </div>
                                  </>
                                } else {
                                  return ( <>
                                    <div>
                                      <span className='fw-bold fs-6 me-1'><TransText i18nKey={'report.startTime'} /></span> 
                                      <span className='fs-6'>{startDateParts}</span>
                                    </div>      
                                    <div>
                                      <span className='fw-bold fs-6 me-1'><TransText i18nKey={'report.endTime'} /></span> 
                                      <span className='fs-6'>{endDateParts}</span>
                                    </div>
                                  </>);
                                }
                              })()
                            } 
                            <span className='fw-bold fs-6 me-1'><TransText i18nKey={'report.totalTime'} /></span> 
                            {(() => {
                              if (completationData.startDate && completationData.endtDate) {
                                const startDatePart = completationData.startDate.split(' ')[0];
                                const endDatePart = completationData.endtDate.split(' ')[0];
                                
                                if (startDatePart === endDatePart) {
                                  const startTime = completationData.startDate.split(' ')[1];
                                  const endTime = completationData.endtDate.split(' ')[1];
                                  
                                  const [startHour, startMin, startSec] = startTime.split(':').map(Number);
                                  const [endHour, endMin, endSec] = endTime.split(':').map(Number);
                                  
                                  const startMs = (startHour * 3600 + startMin * 60 + startSec) * 1000;
                                  const endMs = (endHour * 3600 + endMin * 60 + endSec) * 1000;
                                  
                                  const diffMs = endMs - startMs;
                                  const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
                                  const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                                  return <span className="fs-6">
                                    {diffHrs === 0 
                                      ? `${diffMins} ${diffMins === 1 ? 'minuto' : 'minuti'}`
                                      : `${diffHrs} ${diffHrs === 1 ? 'ora' : 'ore'} e ${diffMins} ${diffMins === 1 ? 'minuto' : 'minuti'}`
                                    }
                                  </span>;
                                } else {
                                  const [startDay, startMonth, startYear] = startDatePart.split('/').map(Number);
                                  const [endDay, endMonth, endYear] = endDatePart.split('/').map(Number);
                                  const startDate = new Date(startYear, startMonth - 1, startDay);
                                  const endDate = new Date(endYear, endMonth - 1, endDay);
                                  const diffTime = Math.abs(endDate - startDate);
                                  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                  
                                  return <span className="fs-6">{`${diffDays} ${diffDays === 1 ? 'giorno' : 'giorni'}`}</span>;
                                }
                              }
                              return '';
                            })()
                            }
                          </div> 
                        </Card>
                      </Badge.Ribbon>
                    </Col>
                  </Row>
                  
                  <div className='mt-0'>
                    <div className='fw-semibold fs-4 text-center ms-3 mb-3'>
                      <TransText i18nKey={'report.completedProfiles'} />
                    </div>

                    {loading ? (
                      <div className="text-center p-5">
                        <Spin size="large" />
                        <div className="mt-3">Caricamento dati in corso...</div>
                      </div>
                    ) : error ? (
                      <Alert 
                        message="Errore" 
                        description={error} 
                        type="error" 
                        showIcon 
                        className="mb-4" 
                      />
                    ) : patientSummary.length === 0 ? (
                      <Alert
                        message="Nessun dato disponibile"
                        description="Non ci sono dati di compilazione disponibili per questo medico."
                        type="info"
                        showIcon
                        className="mb-4"
                      />
                    ) : (
                      <Card>
                        <div className="row">
                          <div className="d-flex justify-content-around mb-0">
                            {patientSummary.slice(0, 3).map((category, index) => {
                              const chartData = [
                                { name: "Completati", value: category.completati, fill: "var(--second-color)" },
                                { name: "Non completati", value: category.nonCompletati, fill: "#E0E0E0" }
                              ];
                              
                              return (
                                <div key={index} className="text-center" style={{ width: "30%" }}>
                                  <div className="fs-5 fw-semibold mb-0">Paziente {category.cluster}</div>

                                  <div className="fs-6 mt-0">
                                    {category.completati}/{category.totali} completati
                                  </div>
                                  <ResponsiveContainer width="100%" height={120}>
                                    <PieChart>
                                      <Pie
                                        data={chartData}
                                        dataKey="value"
                                        cx="50%"
                                        cy="50%"
                                        outerRadius={50}
                                        labelLine={false}
                                        label={({ value }) => `${value}`}
                                        isAnimationActive={false}
                                      />
                                    </PieChart>
                                  </ResponsiveContainer>
                                </div>
                              );
                            })}
                          </div>

                          {patientSummary.length > 3 && (
                            <div className="d-flex justify-content-center">
                              {patientSummary.slice(3, 5).map((category, index) => {
                                const chartData = [
                                  { name: "Completati", value: category.completati, fill: "var(--second-color)" },
                                  { name: "Non completati", value: category.nonCompletati, fill: "#E0E0E0" }
                                ];
                                
                                return (
                                  <div key={index + 3} className="text-center mx-4" style={{ width: "30%" }}>
                                    <div className="fs-5 fw-semibold mb-0">Paziente {category.cluster}</div>
                                    <div className="mt-0 fs-6">
                                      {category.completati}/{category.totali} completati
                                    </div>
                                    <ResponsiveContainer width="100%" height={120}>
                                      <PieChart>
                                        <Pie
                                          data={chartData}
                                          dataKey="value"
                                          cx="50%"
                                          cy="50%"
                                          outerRadius={50}
                                          labelLine={false}
                                          label={({ value }) => `${value}`}
                                          isAnimationActive={false}
                                        />
                                      </PieChart>
                                    </ResponsiveContainer>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </Card>
                    )}
                  </div>
                </div>
                </div>

                <div className='position-absolute bottom-0 p-4 start-0 end-0 w-100'>
                  <div style={{
                    padding: 0,
                    // height: '80px',
                    width: '100%',
                    backgroundColor: '#fff',
                  }}>
                    <div className="d-flex justify-content-center align-items-center h-100">
                      <div className="d-flex justify-content-between align-items-center gap-2 mx-5" >
                        <img src={Footer1} style={{ height: '4vh', width: "7vw" }} />
                        <img src={Footer2} style={{ height: '4vh', width: "4vw" }} />
                        <img src={Footer3} style={{ height: '4vh', width: "8vw" }} />
                        <img src={Footer4} style={{ height: '4vh', width: "15vw" }} />
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className ="button-responsive fs-6"
                onClick={() => setModalVisible(false)}
              >
                Chiudi
              </Button>
            </Modal.Footer>
          </Modal>
          
          <Modal
            show={secondModalVisible}
            onHide={() => setSecondModalVisible(false)}
            size="lg"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Anteprima: Attestato di partecipazione</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }} className ="bg-light">
              <div className="document-preview" style={{ transform: 'scale(0.7)', transformOrigin: 'top center' }}>
              <Card id="attestato-card" className='card-report' ref={cardRef2}>
                <div className="w-100">
                {/* Document header with logos */}
                <div className="row header-row d-flex justify-content-between align-items-center">
                    <img src={logo_toscana} alt="Logo Toscana" style={{ height: '4vh', width: 'auto' }} className="p-0 ms-2"/>
                    <img src={scritta_toscana} alt="Scritta Toscana" style={{ height: '8vh', width: 'auto' }}/>
                    <img src={logo_estar} alt="Logo Estar" style={{ height: '4vh', width: 'auto' }} className="p-0"/>
                    <img src={Formas} alt="Logo Formas" style={{ height: '4vh', width: 'auto' }} className="p-0"/>
                    <img src={logo_fse} alt="Logo FSE" style={{ height: '5vh', width: 'auto' }} className="p-0 me-3 ms-auto"/>
                </div>
                
                
                {/* Document content that matches the preview */}
                <div className='mt-5 pt-4 d-flex justify-content-center align-items-center flex-column'>
                  <h2 className='text-center mt-3 mb-2'  style={{color:"#364C8C"}}>ATTESTATO<br/> DI PARTECIPAZIONE</h2>
                  
                  {/* Certificate content */}
                  <div className="text-center py-4">
                    <h2 className="mb-2">
                      {`${reportData?.infoMedico?.firstName || ''} ${reportData?.infoMedico?.lastName || ''}`}
                    </h2>
                    <div className="d-flex justify-content-center">
                      <p className ="fs-5 fw-semibold my-2" >
                          ha partecipato al
                      </p>
                    </div>

                      <p className="fs-4 mx-5 my-3 border-bottom border-top pt-4 pb-4">
                        <span className="fw-semibold"  style={{color:"#364C8C"}}>
                          CORSO DI FORMAZIONE IN AFFIANCAMENTO <br />
                          sul Fascicolo Sanitario Elettronico 2.0<br /> 
                          dedicato ai Medici di Medicina Generale e Pediatri di Libera Scelta
                        </span>
                        <br />
                      </p>                   
                      <div className="text-center mb-5">
                          <p className ="fs-5">della durata di 4 ore</p>
                      </div>
                    </div>
              </div>
              <div className="d-flex justify-content-end me-4 mt-5">
                {/* <p className="fs-5">Data di formazione: <br /> */}
                <p>{completationData.endtDate?.split(' ')[0]}</p>
              </div>

                {/* Footer with logos */}
                <div className='position-absolute bottom-0 p-4 start-0 end-0 w-100'>
                  <div style={{
                    padding: 0,
                    // height: '80px',
                    width: '100%',
                    backgroundColor: '#fff',
                  }}>
                    <div className="d-flex justify-content-center align-items-center h-100">
                      <div className="d-flex justify-content-between align-items-center gap-2 mx-5" >
                        <img src={Footer1} style={{ height: '4vh', width: "7vw" }} />
                        <img src={Footer2} style={{ height: '4vh', width: "4vw" }} />
                        <img src={Footer3} style={{ height: '4vh', width: "8vw" }} />
                        <img src={Footer4} style={{ height: '4vh', width: "15vw" }} />
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </Card>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className ="button-responsive fs-6"
                onClick={() => setSecondModalVisible(false)}
              >
                Chiudi
              </Button>
            </Modal.Footer>
          </Modal>



        </div>
      )}
      
      {!doctorData && (
        <div className="ms-4 mt-4 me-4">
          <h2>Errore: Dati del medico non disponibili</h2>
          <Button onClick={() => navigate('/doctor-list')}>
            <TransText i18nkey={"patientList.back"} />
          </Button>
        </div>
      )}
      </div>
    </>
  );
};

export default PatientReport;